export const SideMenuActionTypes = {
  COLLAPSE_MENU: "COLLAPSE_MENU",
  SET_COLLAPSE_STATE: "SET_COLLAPSE_STATE"
};
